export default "__VITE_ASSET__Dt_SEYT6__"